// You can write more code here

/* START OF COMPILED CODE */

import HUDButton from '../../GeneralUI/Buttons/HUDButton';
/* START-USER-IMPORTS */
import HUDController from '@/game/prefabs/WorldUI/HUD/HUDController';
/* END-USER-IMPORTS */

export default class HUD extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // curtain
    const curtain = scene.add.image(0, 0, '1x1sprite');
    curtain.scaleX = 1024;
    curtain.scaleY = 768;
    curtain.setOrigin(0, 0);
    curtain.visible = false;
    curtain.tintTopLeft = 0;
    curtain.tintTopRight = 0;
    curtain.tintBottomLeft = 0;
    curtain.tintBottomRight = 0;
    this.add(curtain);

    // rightPanel_m
    const rightPanel_m = scene.add.container(1024, 0);
    rightPanel_m.scaleX = 2;
    rightPanel_m.scaleY = 2;
    this.add(rightPanel_m);

    // compressedBacking_m
    const compressedBacking_m = scene.add.nineslice(
      -8,
      8,
      'Hud3',
      undefined,
      32,
      24,
      12,
      12,
      12,
      12,
    );
    compressedBacking_m.scaleX = 2;
    compressedBacking_m.scaleY = 2;
    compressedBacking_m.setOrigin(1, 0);
    rightPanel_m.add(compressedBacking_m);

    // collapsableElements
    const collapsableElements = scene.add.container(0, 0);
    rightPanel_m.add(collapsableElements);

    // nineslice_m
    const nineslice_m = scene.add.nineslice(
      -8,
      8,
      'Hud3',
      undefined,
      172,
      24,
      12,
      12,
      12,
      12,
    );
    nineslice_m.scaleX = 2;
    nineslice_m.scaleY = 2;
    nineslice_m.setOrigin(1, 0);
    collapsableElements.add(nineslice_m);

    // logoutButton_m
    const logoutButton_m = new HUDButton(scene, -74, 32, 'exit1');
    logoutButton_m.scaleX = 2;
    logoutButton_m.scaleY = 2;
    collapsableElements.add(logoutButton_m);

    // settingsButton_m
    const settingsButton_m = new HUDButton(scene, -282, 32, 'hud-icons', 131);
    collapsableElements.add(settingsButton_m);

    // dailiesButton_m
    const dailiesButton_m = new HUDButton(scene, -142, 32, 'daily_activities2');
    dailiesButton_m.scaleX = 2;
    dailiesButton_m.scaleY = 2;
    collapsableElements.add(dailiesButton_m);

    // masteriesButton_m
    const masteriesButton_m = new HUDButton(scene, -174, 32, 'mastery3');
    collapsableElements.add(masteriesButton_m);

    // shopButton_m
    const shopButton_m = new HUDButton(scene, -210, 32, 'shop1');
    shopButton_m.scaleX = 2;
    shopButton_m.scaleY = 2;
    collapsableElements.add(shopButton_m);

    // inventoryButton_m
    const inventoryButton_m = new HUDButton(scene, -246, 32, 'bag3');
    inventoryButton_m.scaleX = 2;
    inventoryButton_m.scaleY = 2;
    collapsableElements.add(inventoryButton_m);

    // helpButton_m
    const helpButton_m = new HUDButton(scene, -110, 32, 'help3');
    helpButton_m.scaleX = 2;
    helpButton_m.scaleY = 2;
    collapsableElements.add(helpButton_m);

    // gemContainer_m
    const gemContainer_m = scene.add.container(0, 60);
    collapsableElements.add(gemContainer_m);

    // currencyBacking
    const currencyBacking = scene.add.nineslice(
      -20,
      12,
      'fadeOut',
      undefined,
      50,
      12,
      3,
      1,
      1,
      1,
    );
    currencyBacking.scaleX = 2;
    currencyBacking.scaleY = 2;
    currencyBacking.setOrigin(1, 0.5);
    currencyBacking.alpha = 0.75;
    currencyBacking.tint = 4864576;
    gemContainer_m.add(currencyBacking);

    // coinsLabel_m
    const coinsLabel_m = scene.add.bitmapText(-36, 12, 'Aronui', '-');
    coinsLabel_m.setOrigin(1, 0.5);
    coinsLabel_m.tintTopLeft = 15130076;
    coinsLabel_m.tintTopRight = 15130076;
    coinsLabel_m.tintBottomLeft = 15130076;
    coinsLabel_m.tintBottomRight = 15130076;
    coinsLabel_m.text = '-';
    coinsLabel_m.fontSize = -18;
    coinsLabel_m.dropShadowX = 1;
    coinsLabel_m.dropShadowY = 1;
    gemContainer_m.add(coinsLabel_m);

    // currencyIcon_m
    const currencyIcon_m = scene.add.image(-4, 12, 'hud-icons', 95);
    currencyIcon_m.scaleX = 2;
    currencyIcon_m.scaleY = 2;
    currencyIcon_m.setOrigin(1, 0.5);
    gemContainer_m.add(currencyIcon_m);

    // toggleGuidesButton_m
    const toggleGuidesButton_m = new HUDButton(scene, -318, 32, 'npc_locator');
    collapsableElements.add(toggleGuidesButton_m);

    // currencyBacking_1
    const currencyBacking_1 = scene.add.nineslice(
      -40,
      100,
      'fadeOut',
      undefined,
      40,
      12,
      3,
      1,
      1,
      1,
    );
    currencyBacking_1.scaleX = 2;
    currencyBacking_1.scaleY = 2;
    currencyBacking_1.setOrigin(1, 0.5);
    currencyBacking_1.alpha = 0.75;
    currencyBacking_1.tint = 4864576;
    collapsableElements.add(currencyBacking_1);

    // remainingNPCsText_m
    const remainingNPCsText_m = scene.add.bitmapText(-68, 100, 'Aronui', '-');
    remainingNPCsText_m.setOrigin(1, 0.5);
    remainingNPCsText_m.tintTopLeft = 15130076;
    remainingNPCsText_m.tintTopRight = 15130076;
    remainingNPCsText_m.tintBottomLeft = 15130076;
    remainingNPCsText_m.tintBottomRight = 15130076;
    remainingNPCsText_m.text = '-';
    remainingNPCsText_m.fontSize = -18;
    remainingNPCsText_m.dropShadowX = 1;
    remainingNPCsText_m.dropShadowY = 1;
    collapsableElements.add(remainingNPCsText_m);

    // heartIcon_m
    const heartIcon_m = scene.add.image(-38, 114, 'complete');
    heartIcon_m.scaleX = 2;
    heartIcon_m.scaleY = 2;
    collapsableElements.add(heartIcon_m);

    // expandCollapseButton_m
    const expandCollapseButton_m = new HUDButton(scene, -40, 32, 'collapse');
    expandCollapseButton_m.scaleX = 2;
    expandCollapseButton_m.scaleY = 2;
    rightPanel_m.add(expandCollapseButton_m);

    // notificationContainer_m
    const notificationContainer_m = scene.add.container(0, 144);
    notificationContainer_m.scaleX = 0.5;
    notificationContainer_m.scaleY = 0.5;
    rightPanel_m.add(notificationContainer_m);

    // rightPanel
    const rightPanel = scene.add.container(1024, 0);
    rightPanel.scaleX = 2;
    rightPanel.scaleY = 2;
    this.add(rightPanel);

    // nineslice_1
    const nineslice_1 = scene.add.nineslice(
      -8,
      8,
      'Hud3',
      undefined,
      138,
      24,
      12,
      12,
      12,
      12,
    );
    nineslice_1.scaleX = 2;
    nineslice_1.scaleY = 2;
    nineslice_1.setOrigin(1, 0);
    rightPanel.add(nineslice_1);

    // logoutButton
    const logoutButton = new HUDButton(scene, -40, 32, 'exit1');
    logoutButton.scaleX = 2;
    logoutButton.scaleY = 2;
    rightPanel.add(logoutButton);

    // settingsButton
    const settingsButton = new HUDButton(scene, -248, 32, 'hud-icons', 131);
    rightPanel.add(settingsButton);

    // dailiesButton
    const dailiesButton = new HUDButton(scene, -108, 32, 'daily_activities2');
    dailiesButton.scaleX = 2;
    dailiesButton.scaleY = 2;
    rightPanel.add(dailiesButton);

    // masteriesButton
    const masteriesButton = new HUDButton(scene, -140, 32, 'mastery3');
    masteriesButton.visible = true;
    rightPanel.add(masteriesButton);

    // shopButton
    const shopButton = new HUDButton(scene, -176, 32, 'shop1');
    shopButton.scaleX = 2;
    shopButton.scaleY = 2;
    rightPanel.add(shopButton);

    // inventoryButton
    const inventoryButton = new HUDButton(scene, -212, 32, 'bag3');
    inventoryButton.scaleX = 2;
    inventoryButton.scaleY = 2;
    rightPanel.add(inventoryButton);

    // helpButton
    const helpButton = new HUDButton(scene, -76, 32, 'help3');
    helpButton.scaleX = 2;
    helpButton.scaleY = 2;
    rightPanel.add(helpButton);

    // gemContainer
    const gemContainer = scene.add.container(0, 60);
    rightPanel.add(gemContainer);

    // currencyBacking_2
    const currencyBacking_2 = scene.add.nineslice(
      -18,
      12,
      'fadeOut',
      undefined,
      50,
      12,
      3,
      1,
      1,
      1,
    );
    currencyBacking_2.scaleX = 2;
    currencyBacking_2.scaleY = 2;
    currencyBacking_2.setOrigin(1, 0.5);
    currencyBacking_2.alpha = 0.75;
    currencyBacking_2.tint = 4864576;
    gemContainer.add(currencyBacking_2);

    // coinsLabel
    const coinsLabel = scene.add.bitmapText(-36, 12, 'Aronui', '-');
    coinsLabel.setOrigin(1, 0.5);
    coinsLabel.tintTopLeft = 15130076;
    coinsLabel.tintTopRight = 15130076;
    coinsLabel.tintBottomLeft = 15130076;
    coinsLabel.tintBottomRight = 15130076;
    coinsLabel.text = '-';
    coinsLabel.fontSize = -18;
    coinsLabel.dropShadowX = 1;
    coinsLabel.dropShadowY = 1;
    gemContainer.add(coinsLabel);

    // currencyIcon
    const currencyIcon = scene.add.image(-4, 12, 'hud-icons', 95);
    currencyIcon.scaleX = 2;
    currencyIcon.scaleY = 2;
    currencyIcon.setOrigin(1, 0.5);
    gemContainer.add(currencyIcon);

    // notificationContainer
    const notificationContainer = scene.add.container(0, 88);
    notificationContainer.scaleX = 0.5;
    notificationContainer.scaleY = 0.5;
    rightPanel.add(notificationContainer);

    // leftPanel_m
    const leftPanel_m = scene.add.container(0, 0);
    leftPanel_m.visible = false;
    this.add(leftPanel_m);

    // leftPanel
    const leftPanel = scene.add.container(0, 0);
    leftPanel.scaleX = 2;
    leftPanel.scaleY = 2;
    this.add(leftPanel);

    // toggleGuidesBacking
    const toggleGuidesBacking = scene.add.nineslice(
      40,
      32,
      'Hud3',
      undefined,
      32,
      24,
      12,
      12,
      12,
      12,
    );
    toggleGuidesBacking.scaleX = 2;
    toggleGuidesBacking.scaleY = 2;
    leftPanel.add(toggleGuidesBacking);

    // remainingNpcsBacking
    const remainingNpcsBacking = scene.add.nineslice(
      126,
      32,
      'fadeOut',
      undefined,
      35,
      12,
      3,
      1,
      1,
      1,
    );
    remainingNpcsBacking.scaleX = -2;
    remainingNpcsBacking.scaleY = 2;
    remainingNpcsBacking.setOrigin(1, 0.5);
    remainingNpcsBacking.alpha = 0.75;
    remainingNpcsBacking.tint = 4864576;
    leftPanel.add(remainingNpcsBacking);

    // toggleGuidesButton
    const toggleGuidesButton = new HUDButton(scene, 40, 32, 'npc_locator');
    leftPanel.add(toggleGuidesButton);

    // heartIcon
    const heartIcon = scene.add.image(108, 32, 'complete');
    heartIcon.scaleX = 2;
    heartIcon.scaleY = 2;
    leftPanel.add(heartIcon);

    // remainingNPCsText
    const remainingNPCsText = scene.add.bitmapText(140, 32, 'Aronui', '-');
    remainingNPCsText.setOrigin(0, 0.5);
    remainingNPCsText.tintTopLeft = 15130076;
    remainingNPCsText.tintTopRight = 15130076;
    remainingNPCsText.tintBottomLeft = 15130076;
    remainingNPCsText.tintBottomRight = 15130076;
    remainingNPCsText.text = '-';
    remainingNPCsText.fontSize = -18;
    remainingNPCsText.dropShadowX = 1;
    remainingNPCsText.dropShadowY = 1;
    leftPanel.add(remainingNPCsText);

    // buyAllItemsButton
    const buyAllItemsButton = new HUDButton(scene, 32, 116, 'shop2');
    buyAllItemsButton.scaleX = 2;
    buyAllItemsButton.scaleY = 2;
    leftPanel.add(buyAllItemsButton);

    // completeAllNodesButton
    const completeAllNodesButton = new HUDButton(
      scene,
      32,
      76,
      'hud-icons',
      132,
    );
    completeAllNodesButton.scaleX = 2;
    completeAllNodesButton.scaleY = 2;
    leftPanel.add(completeAllNodesButton);

    // logoutButton_m (prefab fields)
    logoutButton_m.defaultIcon = '0';
    logoutButton_m.hoverIcon = '0';
    logoutButton_m.pressButton = '0';
    logoutButton_m.useAlternateTextures = false;

    // settingsButton_m (prefab fields)
    settingsButton_m.defaultIcon = '18';
    settingsButton_m.pressButton = '50';
    settingsButton_m.useAlternateTextures = false;

    // dailiesButton_m (prefab fields)
    dailiesButton_m.defaultIcon = '253';
    dailiesButton_m.hoverIcon = '253';
    dailiesButton_m.pressButton = '253';
    dailiesButton_m.useAlternateTextures = false;

    // masteriesButton_m (prefab fields)
    masteriesButton_m.useAlternateTextures = false;

    // shopButton_m (prefab fields)
    shopButton_m.defaultIcon = '94';
    shopButton_m.hoverIcon = '94';
    shopButton_m.pressButton = '94';
    shopButton_m.useAlternateTextures = false;

    // inventoryButton_m (prefab fields)
    inventoryButton_m.defaultIcon = '94';
    inventoryButton_m.hoverIcon = '94';
    inventoryButton_m.pressButton = '94';
    inventoryButton_m.useAlternateTextures = false;

    // helpButton_m (prefab fields)
    helpButton_m.defaultIcon = '94';
    helpButton_m.hoverIcon = '94';
    helpButton_m.pressButton = '94';
    helpButton_m.useAlternateTextures = false;

    // toggleGuidesButton_m (prefab fields)
    toggleGuidesButton_m.useAlternateTextures = false;

    // expandCollapseButton_m (prefab fields)
    expandCollapseButton_m.defaultIcon = '0';
    expandCollapseButton_m.hoverIcon = '0';
    expandCollapseButton_m.pressButton = '0';
    expandCollapseButton_m.useAlternateTextures = false;

    // logoutButton (prefab fields)
    logoutButton.defaultIcon = '0';
    logoutButton.hoverIcon = '0';
    logoutButton.pressButton = '0';
    logoutButton.useAlternateTextures = false;

    // settingsButton (prefab fields)
    settingsButton.defaultIcon = '18';
    settingsButton.pressButton = '50';
    settingsButton.useAlternateTextures = false;

    // dailiesButton (prefab fields)
    dailiesButton.defaultIcon = '253';
    dailiesButton.hoverIcon = '253';
    dailiesButton.pressButton = '253';
    dailiesButton.useAlternateTextures = false;

    // masteriesButton (prefab fields)
    masteriesButton.useAlternateTextures = false;

    // shopButton (prefab fields)
    shopButton.defaultIcon = '94';
    shopButton.hoverIcon = '94';
    shopButton.pressButton = '94';
    shopButton.useAlternateTextures = false;

    // inventoryButton (prefab fields)
    inventoryButton.defaultIcon = '94';
    inventoryButton.hoverIcon = '94';
    inventoryButton.pressButton = '94';
    inventoryButton.useAlternateTextures = false;

    // helpButton (prefab fields)
    helpButton.defaultIcon = '94';
    helpButton.hoverIcon = '94';
    helpButton.pressButton = '94';
    helpButton.useAlternateTextures = false;

    // toggleGuidesButton (prefab fields)
    toggleGuidesButton.useAlternateTextures = false;

    // buyAllItemsButton (prefab fields)
    buyAllItemsButton.useAlternateTextures = false;

    // completeAllNodesButton (prefab fields)
    completeAllNodesButton.useAlternateTextures = false;

    this.curtain = curtain;
    this.logoutButton_m = logoutButton_m;
    this.settingsButton_m = settingsButton_m;
    this.dailiesButton_m = dailiesButton_m;
    this.masteriesButton_m = masteriesButton_m;
    this.shopButton_m = shopButton_m;
    this.inventoryButton_m = inventoryButton_m;
    this.helpButton_m = helpButton_m;
    this.coinsLabel_m = coinsLabel_m;
    this.toggleGuidesButton_m = toggleGuidesButton_m;
    this.remainingNPCsText_m = remainingNPCsText_m;
    this.heartIcon_m = heartIcon_m;
    this.collapsableElements = collapsableElements;
    this.expandCollapseButton_m = expandCollapseButton_m;
    this.notificationContainer_m = notificationContainer_m;
    this.rightPanel_m = rightPanel_m;
    this.logoutButton = logoutButton;
    this.settingsButton = settingsButton;
    this.dailiesButton = dailiesButton;
    this.masteriesButton = masteriesButton;
    this.shopButton = shopButton;
    this.inventoryButton = inventoryButton;
    this.helpButton = helpButton;
    this.coinsLabel = coinsLabel;
    this.notificationContainer = notificationContainer;
    this.rightPanel = rightPanel;
    this.leftPanel_m = leftPanel_m;
    this.toggleGuidesButton = toggleGuidesButton;
    this.heartIcon = heartIcon;
    this.remainingNPCsText = remainingNPCsText;
    this.buyAllItemsButton = buyAllItemsButton;
    this.completeAllNodesButton = completeAllNodesButton;
    this.leftPanel = leftPanel;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    this._controller = new HUDController(this);

    /* END-USER-CTR-CODE */
  }

  public curtain: Phaser.GameObjects.Image;
  public logoutButton_m: HUDButton;
  public settingsButton_m: HUDButton;
  public dailiesButton_m: HUDButton;
  public masteriesButton_m: HUDButton;
  public shopButton_m: HUDButton;
  public inventoryButton_m: HUDButton;
  public helpButton_m: HUDButton;
  public coinsLabel_m: Phaser.GameObjects.BitmapText;
  public toggleGuidesButton_m: HUDButton;
  public remainingNPCsText_m: Phaser.GameObjects.BitmapText;
  public heartIcon_m: Phaser.GameObjects.Image;
  public collapsableElements: Phaser.GameObjects.Container;
  public expandCollapseButton_m: HUDButton;
  public notificationContainer_m: Phaser.GameObjects.Container;
  public rightPanel_m: Phaser.GameObjects.Container;
  public logoutButton: HUDButton;
  public settingsButton: HUDButton;
  public dailiesButton: HUDButton;
  public masteriesButton: HUDButton;
  public shopButton: HUDButton;
  public inventoryButton: HUDButton;
  public helpButton: HUDButton;
  public coinsLabel: Phaser.GameObjects.BitmapText;
  public notificationContainer: Phaser.GameObjects.Container;
  public rightPanel: Phaser.GameObjects.Container;
  public leftPanel_m: Phaser.GameObjects.Container;
  public toggleGuidesButton: HUDButton;
  public heartIcon: Phaser.GameObjects.Image;
  public remainingNPCsText: Phaser.GameObjects.BitmapText;
  public buyAllItemsButton: HUDButton;
  public completeAllNodesButton: HUDButton;
  public leftPanel: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  private _controller: HUDController;
  get controller() {
    return this._controller;
  }

  awake() {
    this._controller.awake();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
